<div class="">
  <div class="land_parcellation tab_content" id="content2" data-tab="2">
    <!-- form FORM====================================FORM FORM=====================FORM -->

    <div class="form_input">
      <form [formGroup]="landParcelForm">
        <div class="top">
          <h2 class="title">Land Parcellation</h2>
        </div>

        <div class="input">
          <label for="">Row ID Linkage</label>
          <input
            type="number"
            (input)="onPopulateUrl()"
            formControlName="RowIdLinkage"
            class="default_input reference-form"
          />
        </div>
        <div class="input">
          <label for="">Section Name</label>
          <input
            type="text"
            formControlName="SectionName"
            class="default_input reference-form"
          />
        </div>
        <div class="input">
          <label for="">Purpose</label>
          <select
            formControlName="PurposeId"
            class="default_input reference-form"
          >
            <option *ngFor="let purpose of purposes" [value]="purpose.id">{{
              purpose.PurposeName
            }}</option>
          </select>
        </div>

        <div class="input">
          <label for="">Net Area</label>
          <input
            type="number"
            (input)="onInput()"
            formControlName="TotalArea"
            class="default_input reference-form"
          />
        </div>
        <div class="input">
          <label for="">Measuring Unit</label>
          <select
            (change)="onMeasure($event.target.value)"
            formControlName="MeasureId"
            class="default_input reference-form"
          >
            <option *ngFor="let measure of measures" [value]="measure.id">{{
              measure.MeasureName
            }}</option>
          </select>
        </div>

        <div class="input">
          <label for="">Cost</label>
          <input
            type="number"
            formControlName="Cost"
            class="default_input reference-form"
          />
        </div>
        <div class="input">
          <label for="">Map Url</label>
          <input
            type="text"
            formControlName="URLMap"
            class="default_input reference-form"
          />
        </div>

        <div class="btn_holder">
          <button
            class="default_primary-button"
            (click)="addNew(landParcelForm.value)"
            type="submit"
          >
            <ng-container *ngIf="selectedIndex === null">
              Add &rarr;
            </ng-container>
            <ng-container *ngIf="selectedIndex !== null">
              Update &rarr;
            </ng-container>
          </button>

          <div class="refresh">
          <button mat-button (click)="onReset()">
             <i class="material-icons">
              settings_backup_restore
              </i>Reset</button>
          </div>
        </div>
      </form>
    </div>

    <cradua-land-parcellation-table
      [selectedLandTitle]="selectedLandTitle"
      [purposes]="purposes"
      [measures]="measures"
      [landParcels]="landParcels"
      [measuringFactors]="measuringFactors"
      [appConfigs]="appConfigs"
      (emitEdit)="onEdit($event)"
    >
    </cradua-land-parcellation-table>

  </div>

  <div class="acquisition_submit">
    <button *ngIf="activitySelectedValue === 'readwrite'" class="default_primary-button" (click)="onSubmit()" type="submit">
      Save
    </button>
  </div>
</div>
